import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { UserOrderContext } from 'context/context';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import PastOrderListComponent from '../Presentation/PastOrderListComponent';
import ImageComponent from 'atoms/Image/index';
import { CAROUSAL_CONFIG } from '../Constants/Constants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import SampleArrowNext from 'organisms/OffersAndPromotions/Presentation/SampleArrowNext';
import SampleArrowPrev from 'organisms/OffersAndPromotions/Presentation/SampleArrowPrev';
import { getFormatFromUnix } from 'common/utilities/dayJsUtils';
import ReorderContainerGlobal from 'organisms/ReorderComponentGlobal/Container/ReorderContainer';
import {
  LOCAL_STORAGE_KEYS,
  ROUTE_URL,
  REORDER_CONSTANTS,
  CATERING,
  DATE_FORMATS,
} from 'common/constants/SharedConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { localisationStartAnalytics } from 'common/utilities/analyticsUtils';
import CONTEXT_REDUCER_MAPPING_KEY from 'common/constants/ContextReducerKeys';
const {SET_LOCATION_INFO}=CONTEXT_REDUCER_MAPPING_KEY;

function getMergerdOrders(pastOrdersData, favouriteOrders) {
  return [
    ...favouriteOrders,
    ...pastOrdersData?.slice()?.filter(o => favouriteOrders.find(f => f.id === o.id) === undefined),
  ];
}
function filterCateringOrder(data) {
  return data.filter(data => data.service !== CATERING);
}

export const getDate = dateData =>
  `${translateWithI18Next(getFormatFromUnix(dateData, DATE_FORMATS.DDDD))}, ${translateWithI18Next(
    getFormatFromUnix(dateData, DATE_FORMATS.MMMM),
  )} ${getFormatFromUnix(dateData, DATE_FORMATS.D)}`;

const PastOrderComponent = props => {
  const { pastOrders, basic, favouriteOrders, tenantReducerData, isLoggedIn } = props;
  const {
    currencyConversionFactor,
    currencySymbol,
    componentOptions = {},
    accountdashboardpreviousordercount,
  } = tenantReducerData;
  const { homePage: homepageContant = {} } = componentOptions;
  const { pastorderFullOrderHistoryShowBtn = false } = homepageContant;

  const history = useHistory();
  const { MY_ACCOUNT, ORDER_IT_AGAIN, SEE_FULL_ORDER_HISTORY, WELCOME_BACK, WELCOME_TO, KFC_LOVER, KFC_TEXT } =
    TRANSLATE_MAPPING_KEY;
  const [currentSlide, updateCurrentSlide] = useState(0);
  const [currentOrderInfo, setCurrentOrderInfo] = useState({});
  const carousal = useRef(null);
  const { SPEED, SLIDES_TO_SHOW, SLIDES_TO_SCROLL, SILCK_RESPONSIVE_PROPERTY } = CAROUSAL_CONFIG;
  const [rangeValue, updateRangeValue] = useState(0);
  const { REORDER_MODAL_OPEN, FROM_REORDER_MODAL_OPEN, REORDER_STORE_CHANGED } = START_ORDER_CONSTANTS;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const {
    reorderFlag: { reorderModalOpen = false },
  } = userOrderState;
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const sortData = filterCateringOrder(getMergerdOrders(pastOrders, favouriteOrders))?.slice(
    0,
    accountdashboardpreviousordercount,
  );
  const onNextCard = () => {
    if (currentSlide < sortData.length - 1) {
      let updatedCurrentSlide = 0;
      if (currentSlide + SLIDES_TO_SCROLL > sortData.length - SLIDES_TO_SHOW - 1) {
        updatedCurrentSlide = sortData.length - SLIDES_TO_SHOW;
      } else {
        updatedCurrentSlide = currentSlide + SLIDES_TO_SCROLL;
      }
      updateCurrentSlide(updatedCurrentSlide);
      carousal.current.slickGoTo(updatedCurrentSlide);
    }
  };
  const closeButtonHandler = () => {
    userOrderStateDispatch({
      type: SET_LOCATION_INFO,
      value: { selectedDeliveryAddress: '', deliveryAddressLineVal:''},
    });
    userOrderStateDispatch({ type: REORDER_MODAL_OPEN, value: { reorderModalOpen: false } });
    userOrderStateDispatch({ type: FROM_REORDER_MODAL_OPEN, value: { fromReorderFlag: false } });
    userOrderStateDispatch({ type: REORDER_STORE_CHANGED, value: { storeChanged: false } });
  };

  useEffect(() => {
    return () => closeButtonHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* OnClicking Previous Arrow Button */
  const onPrevCard = () => {
    if (currentSlide > 0) {
      updateCurrentSlide(currentSlide - SLIDES_TO_SCROLL);
      carousal.current.slickGoTo(currentSlide - SLIDES_TO_SCROLL);
    }
  };

  const onUpdateRange = event => {
    updateRangeValue(event.target.value);
    carousal.current.slickGoTo(event.target.value);
  };

  const settingsRecommendation = {
    dots: false,
    infinite: false,
    speed: SPEED,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: SLIDES_TO_SCROLL,
    arrows: true,
    adaptiveHeight: false,
    autoplay: false,
    nextArrow: <SampleArrowNext clickNextCard={onNextCard} />,
    prevArrow: <SampleArrowPrev clickPrevCard={onPrevCard} />,
    beforeChange: (current, next) => updateRangeValue(next),
    afterChange: (current, prev) => updateCurrentSlide(current),
    variableWidth: true,
    responsive: SILCK_RESPONSIVE_PROPERTY,
  };

  const reorderBtnHandler = item => {
    !userParams?.localized && localisationStartAnalytics();
    setCurrentOrderInfo(item);
    userOrderStateDispatch({ type: REORDER_MODAL_OPEN, value: { reorderModalOpen: true } });
    userOrderStateDispatch({ type: FROM_REORDER_MODAL_OPEN, value: { fromReorderFlag: true } });
    /* setting true value to reorderClick, to avoid the toast onclick of reorder button */
    sessionStorage.setItem(LOCAL_STORAGE_KEYS.REORDER_CLICK, true);
  };

  const seeFullHistory = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.LOAD_MORE_ORDER_HISTORY);
    history.push({ pathname: ROUTE_URL.ACCOUNT });
    window.scrollTo(0, 0);
  };

  const seeFullHistoryPastOrder = () => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.LOAD_MORE_ORDER_HISTORY, 'GoToOrderHistory');
    history.push({ pathname: ROUTE_URL.ACCOUNT });
    window.scrollTo(0, 0);
  };

  return (
    <div className='pastorder-background'>
      <div className='pastorder-container pastorder-global-container grid-container'>
        {isLoggedIn ? (
          <div className='pastorder-left-container'>
            {/* <div data-testid='pastorder-strips-test' className='pastorder-stripes' /> */}
            <>
              <ReactSVG src={IMAGE_PATH.Stripelarge} />
            </>
            <div
              data-testid='pastorder-greeting-test'
              className='pastorder-greeting-heading user-name-greeting-container'
            >
              <div className='user-name-greeting-container-text'>
                {translateWithI18Next(WELCOME_BACK)},{' '}
                <span className='user-name-greeting'>{basic?.firstName || translateWithI18Next(KFC_LOVER)}</span>
                <span className='user-name-greeting'>!</span>
              </div>
            </div>
            <div className='pastorder-my-account'>
              <div className='pastorder-my-account-text' data-testid='see-full-history' onClick={seeFullHistory}>
                {translateWithI18Next(MY_ACCOUNT)}
                <ImageComponent srcFile={IMAGE_PATH.CTA_Arrow} className='pastorder-my-account-arrow' />
              </div>
            </div>
          </div>
        ) : (
          <div className='pastorder-left-container'>
            {/* <div data-testid='pastorder-strips-test' className='pastorder-stripes' /> */}
            <>
              <ReactSVG src={IMAGE_PATH.Stripelarge} />
            </>
            <div data-testid='pastorder-greeting-test' className='pastorder-greeting-heading'>
              {`${translateWithI18Next(WELCOME_TO)} ${translateWithI18Next(KFC_TEXT)}!`}
            </div>
          </div>
        )}

        {(pastOrders?.length > 0 || favouriteOrders?.length > 0) && (
          <div className='pastorder-right-container'>
            <div className='pastorder-right-header'>
              <div className='pastorder-right-header-text text-au'>{translateWithI18Next(ORDER_IT_AGAIN)}</div>
              <div className='pastorder-right-header-line' />
            </div>
            <PastOrderListComponent
              pastOrdersData={sortData}
              carousal={carousal}
              rangeValue={rangeValue}
              reorderBtnHandler={reorderBtnHandler}
              settingsRecommendation={settingsRecommendation}
              onUpdateRange={onUpdateRange}
              getDate={getDate}
              currencySymbol={currencySymbol}
              currencyConversionFactor={currencyConversionFactor}
            />
            {pastorderFullOrderHistoryShowBtn && (
              <p className='pastorder-full-history' data-testid='see-order-history' onClick={seeFullHistoryPastOrder}>
                {translateWithI18Next(SEE_FULL_ORDER_HISTORY)}
              </p>
            )}
            {reorderModalOpen && (
              <ReorderContainerGlobal
                currentOrderInfo={currentOrderInfo}
                reorderModalOpen={reorderModalOpen}
                closeButtonHandler={closeButtonHandler}
                source={REORDER_CONSTANTS.HOME_FAVOURITES}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PastOrderComponent;
